export abstract class DateFormattingStrategyService {
    abstract format(date:string, country?:string, language?:string):string;

}
